// Shared client-side document store (IndexedDB). Same DB/store the Files page uses,
// so anything saved here (e.g. generated invoices) shows up in Files → its folder.
const DB_NAME = 'ryzenos_files';
const STORE = 'files';

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE, { keyPath: 'id' });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function putFile(rec) {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, 'readwrite').objectStore(STORE).put(rec);
    tx.onsuccess = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

// Save a document (blob) into a named folder so it appears in the Files page.
export async function saveDocument({ name, blob, folder }) {
  const rec = {
    id: Date.now() + '-' + Math.random().toString(36).slice(2, 7),
    name, type: blob.type || '', size: blob.size || 0, date: Date.now(),
    folder: folder || 'General', blob,
  };
  await putFile(rec);
}
